import React, {useRef, useState} from 'react';
import Logo from '../../assets/Images/logo.png';
import {
    HeaderLeftButton,
    HeaderLink,
    HeaderLinks, HeaderLinksContainer, HeaderWrapper, LoginLeftButton,
    LogoContainer, ProfileDropDownOverlay,
    ProfileDropDownWrapper
} from "./header.styles";
import {Link, NavLink, useNavigate} from "react-router-dom";
import gsap from "gsap";
import {
    ProfileDropDownBadge,
    ProfileDropDownDesc,
    ProfileDropDownItem,
    ProfileDropDownItems
} from "../../core-ui/panel-menu/panel-menu-item.styles";
import {useDispatch, useSelector} from 'react-redux';
import {Modal} from "react-responsive-modal";
import {ShiftModalContainer} from "../../pages/Requests/requests.styles";
import {PHARMA_TOK} from "../../helpers/general-variables";
import {setLoginStatus} from "../../redux/user/user.action";
import Notification from "../../helpers/notifications";

const Header = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const isLogin = useSelector(state => state.user.is_login);
    const profileMenuRef = useRef(null);
    const dropDownOverlayRef = useRef(null);
    const mainMenuRef = useRef(null);
    const barRef = useRef(null);
    const [logoutModal, setLogoutModal] = useState(false);

    const profileMenuHandler = () => {

        if (profileMenuRef.current.classList.contains('d-none')) {

            profileMenuRef.current.classList.remove('d-none');
            dropDownOverlayRef.current.classList.remove('d-none');

            gsap.from(profileMenuRef.current, .4, {
                y: -50,
                opacity: 0,
            })
        } else {
            hideDropDownMenu();
        }
    }

    const redirectHandler = (e, route) => {
        e.preventDefault();
        hideDropDownMenu();
        navigate(route);
    }

    const hideDropDownMenu = (onCompleteAction = null) => {

        gsap.to(profileMenuRef.current, .4, {
            y: -50,
            opacity: 0,
            onComplete: () => {
                gsap.set(profileMenuRef.current, {
                    clearProps: "all"
                });
                dropDownOverlayRef.current.classList.add('d-none');
                profileMenuRef.current.classList.add('d-none');
                if (onCompleteAction) {
                    onCompleteAction();
                }
            }
        });
    }

    const logout = () => {
        hideDropDownMenu(() => {
            localStorage.removeItem(PHARMA_TOK);
            dispatch(setLoginStatus(false));
            setLogoutModal(false);
            Notification.warning('از حساب کاربری خود خارج شدید');
            navigate('/');
        });
    }

    const mainMenuHandler = () => {
        if(mainMenuRef.current.classList.contains('close')) {
            mainMenuRef.current.classList.remove('close');
            barRef.current.classList.add('icon-success');
        } else {
            mainMenuRef.current.classList.add('close');
            barRef.current.classList.remove('icon-success');
        }
    }

    return (
        <>
            <HeaderWrapper className='rtl py-3 px-lg-4'>
                <div className='position-relative'>
                    <div className='container-lg d-flex align-items-center'>
                        <div className='d-flex align-items-center'>
                            <button className='ms-3 me-2 d-inline-block d-lg-none btn-text' onClick={mainMenuHandler}>
                                <i className="icon-menu-hamber align-bottom" ref={barRef} />
                            </button>
                            <LogoContainer src={Logo} alt='logo'/>
                        </div>
                        <HeaderLinksContainer className='ms-0 ms-lg-4 close' ref={mainMenuRef}>
                            <HeaderLinks>
                                <HeaderLink>
                                    <NavLink to='/' className='light-gray'>صفحه
                                        نخست</NavLink>
                                </HeaderLink>
                                <HeaderLink>
                                    <NavLink to='/sign-up' className='light-gray'>آموزش</NavLink>
                                </HeaderLink>
                                <HeaderLink>
                                    <NavLink to='/sign-up' className='light-gray'>سوالات
                                        متداول</NavLink>
                                </HeaderLink>
                                <HeaderLink>
                                    <NavLink to='/sign-up' className='light-gray'>تماس
                                        با
                                        ما</NavLink>
                                </HeaderLink>
                            </HeaderLinks>
                        </HeaderLinksContainer>
                        <div className='me-auto ms-0 ms-lg-7 position-relative'>
                            {
                                isLogin ?
                                    <>
                                        <HeaderLeftButton className='c-btn c-btn-warning align-items-center px-4 d-none d-lg-inline-block'
                                                          onClick={profileMenuHandler}>
                                            <i className="icon-user ms-3 align-middle"/>
                                            پروفایل
                                        </HeaderLeftButton>

                                        <Link to='/panel' className='c-btn c-btn-warning align-items-center px-4 d-lg-none btn-rounded-border'>
                                            پنل کاربری
                                        </Link>

                                        <ProfileDropDownWrapper ref={profileMenuRef} className='d-none'>
                                            <ProfileDropDownItems>
                                                <ProfileDropDownItem>
                                                    <Link to='/panel/my-requests'
                                                          onClick={(e) => redirectHandler(e, '/panel/my-requests')}>
                                                        <i className='icon-people'/>
                                                        <p>درخواست‌های من</p>
                                                        <ProfileDropDownDesc>(تقاضای جدیدی ارسال شده)</ProfileDropDownDesc>
                                                        <ProfileDropDownBadge/>
                                                    </Link>
                                                </ProfileDropDownItem>
                                                <ProfileDropDownItem>
                                                    <Link to='/panel/my-shifts'
                                                          onClick={(e) => redirectHandler(e, '/panel/my-shifts')}>
                                                        <i className='icon-clipboard-tick-2'/>
                                                        <p>شیفت های قبول شده</p>
                                                        <ProfileDropDownDesc>(درخواست شما پذیرفته شده)</ProfileDropDownDesc>
                                                        <ProfileDropDownBadge/>
                                                    </Link>
                                                </ProfileDropDownItem>
                                                <ProfileDropDownItem>
                                                    <Link to='/panel/my-account'
                                                          onClick={(e) => redirectHandler(e, '/panel/my-account')}>
                                                        <i className='icon-personalcard'/>
                                                        <p>اطلاعات حساب کاربری</p>
                                                    </Link>
                                                </ProfileDropDownItem>
                                                <ProfileDropDownItem>
                                                    <button onClick={() => setLogoutModal(true)}>
                                                        <i className='icon-logout'/>
                                                        <p>خروج از حساب کاربری</p>
                                                    </button>
                                                </ProfileDropDownItem>
                                            </ProfileDropDownItems>
                                        </ProfileDropDownWrapper>
                                    </> :
                                    <Link to='/login' className='c-btn c-btn-warning btn-rounded-border'>
                                        ورود
                                    </Link>
                            }
                        </div>
                    </div>
                </div>
                <ProfileDropDownOverlay ref={dropDownOverlayRef} onClick={profileMenuHandler}
                                        className='d-none'/>
            </HeaderWrapper>

            <Modal open={logoutModal} onClose={() => setLogoutModal(false)}
                   classNames={{modal: 'c-modal-container c-modal-sw'}}
                   showCloseIcon={false} center>
                <ShiftModalContainer className='row'>
                    <div className='text-center mt-c-2'>
                        <p className='fs-c-3 danger-color'>آیا میخواهید از حساب کاربری خود خارج شوید؟</p>
                        <div className='d-flex align-items-center justify-content-center mt-5 mb-4'>
                            <button className='btn-text me-5' onClick={() => setLogoutModal(false)}>بازگشت به صفحه
                                قبلی
                            </button>
                            <button className='c-btn simple-btn-danger px-3' onClick={logout}>خروج از حساب کاربری
                            </button>
                        </div>
                    </div>
                </ShiftModalContainer>
            </Modal>
        </>
    );
};

export default Header;
